import { selectAllStrings } from '../language/languageSlice';
import { selectFeaturedPoiIds, fetchFeaturedPois } from './poisSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PoisSlider from './PoisSlider';
import '../../stylesheets/FeaturedPoisSection.css';
    
const FeaturedPoisSection = () => {
    const strings = useSelector(selectAllStrings);
    const featuredPoiIds = useSelector(selectFeaturedPoiIds);
    const featuredPoisStatus = useSelector((state) => state.pois.featuredPois.status);
    const featuredPoisError = useSelector((state) => state.pois.featuredPois.error);
    const dispatch = useDispatch();
    
    useEffect(() => {
        if (featuredPoisStatus === 'idle') {
            dispatch(fetchFeaturedPois());
        }
    }, [featuredPoisStatus, dispatch]);
    
    return <div className="featured-pois">
            <h2 className="title">{strings.featured_pois}</h2>
            <Link className="see-all" to={'/featured-pois'}>{strings.see_all}</Link>
            <PoisSlider poiIds={featuredPoiIds} status={featuredPoisStatus} error={featuredPoisError}/>
        </div>
};

export default FeaturedPoisSection;